import axios from "axios";
import { useEffect, useState } from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import window11productgroup from "../../../Assets/images/window11 productgroup.png";
import microsoftAuthorizedReseller from "../../../Assets/images/microsoft_authorized_reseller.png";
import microsoftEdge from "../../../Assets/images/microsoft_edge.png";
import microsoftStore from "../../../Assets/images/microsoft_Store.png";
import gaming from "../../../Assets/images/gaming.png";
import snap_layout from "../../../Assets/images/snap_layout.png";
import microsoft_teams from "../../../Assets/images/microsoft_teams.png";
import widgets from "../../../Assets/images/widgets.png";
import touch_pen from "../../../Assets/images/touch_pen.png";

import microsoftDesktop from "../../../Assets/images/microsoft_desktop.png";

import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const Window11Pro = ({ id }) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getProductById/?productId=${id}`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Window 11 Professional</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={tableData.productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      <h1>{tableData.name}</h1>
                      <p className="retail_version_color">
                        Retail Version |{" "}
                        {tableData?.retailVersion[0]?.split(":").join(": ")}
                      </p>
                      <img
                        src={window11productgroup}
                        alt="Product inner products images"
                        className="mb-4"
                      />
                      <div className="include_product_purchase">
                        <h1 className="font-weight-bold">
                          Included In Your Purchase:
                        </h1>
                        <p>
                          Download Your Software Directly From Microsoft <br />{" "}
                          Activation Key For Windows 11 Professional <br /> PDF
                          Intructions For Download & Activation <br /> Lifetime
                          Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${tableData.salePrice} USD
                      </p>
                      {added.includes(tableData._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => handleAddCart(tableData)}
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoftAuthorizedReseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="extraInfo_tabs mt-4">
            <Row>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing</h5>
                  <p className="mb-0">Retail</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing Term</h5>
                  <p className="mb-0">Lifetime</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Users Supported</h5>
                  <p className="mb-0">1 User </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Devices Supported</h5>
                  <p className="mb-0">1 Device </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Delivery Method</h5>
                  <p className="mb-0">Instant Digital Delivery</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4   ">
                  <h5>Platform Supported</h5>
                  <p className="mb-0">Windows</p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="product_long_description">
            <Row>
              <Col xxl="9" md="9" sm="12">
                <div className="box_shadow mb-2 me-3">
                  <div className="product_main_description top_radius">
                    <h3 className="mb-0">Product Description</h3>
                  </div>
                  <div className="product_white px-4">
                    <Row>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={microsoftEdge}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Microsoft Edge
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            The fast, fun, and secure browser.
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={microsoftStore}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Microsoft Store
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Featuring new functionality and more apps.
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={snap_layout}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Snap Layouts
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Arrange your open windows into perfect grids.
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={microsoftDesktop}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Desktops
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Switch desktops for better organisations.{" "}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={microsoft_teams}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Microsoft Teams
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Reach anyone right from your desktop.{" "}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={touch_pen}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Touch, Pen, Voice
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Express yourself in the way you do best.{" "}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={widgets}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Widgets
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Find the things that matter to you fast.{" "}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl="3"
                        xl="3"
                        lg="6"
                        sm="6"
                        className="products_contents"
                      >
                        <img
                          className=" productImg_description product_white"
                          src={gaming}
                          alt="productDescription"
                        />
                        <div>
                          <h5 className="product_description_head my-3">
                            Gaming
                          </h5>
                          <div className="underLine_border mb-3"></div>
                          <p className="product_description_p mb-5">
                            Experience epic and immersive graphics.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="product_grey">
                    <h3 className="d-flex justify-content-center product_details_heading px-5 pt-5 mb-3">
                      The Most Advanced Protection
                    </h3>
                    <p className="d-flex justify-content-center px-4">
                      A halo of protection to defend against today's cyber
                      threats. Built-in, routinely updated, and at no extra cost
                      to you.
                    </p>
                    <div className="product_grey px-4">
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              BitLocker Encryption
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              If your device is lost or stolen, BitLocker puts
                              everything on lockdown, so no one else can access
                              your systems or data.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Device Encryption
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              If you turn on device encryption, only authorized
                              individuals will be able to access your device and
                              data.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Find My Device
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Keep track of your devices - even your digital
                              pen!
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Firewall & Network Protection
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Your Windows device comes with built-in security
                              features to help safeguard against viruses and
                              malware.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Internet Protection
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              App & Browser control in Windows Security helps
                              protect your device from dangerous apps, files,
                              and downloads.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Parental Controls
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Manage screen time, liimit access to mature
                              content, and control online purchases when you
                              connect accounts.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Secure Boot
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Helps prevent malicious software applications and
                              unauthorized operating systems from loading during
                              the system start-up process.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Windows hello
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Uses facial recognition, fingerprint, or PIN, for
                              a fast, secure, and password-free way to unlock
                              your compatible Windows devices.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Windows Security
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              View and manage the security and health of your
                              device.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="product_white bottom_radius">
                    <h3 className="d-flex justify-content-center product_details_heading px-5 pt-5 mb-3">
                      Windows 11 Pro - Business Management & Development
                    </h3>
                    <p className="d-flex justify-content-center px-4">
                      Cloud management that enables work from anywhere. It's
                      just what businesses need, and which success demands.
                    </p>
                    <div className="product_white px-4 bottom_radius">
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Assigned Access
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows 11 Pro devices run different applications
                              depending on the user and keep indvidual
                              identitiies seperate and secured.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Dynamic Provisioning
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Take a new PC out of the box, turn it on, and
                              transform into a productive organization device,
                              with minimal time and effort.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Group Policy
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Manage PC's, user accounts, and groups. Get easy
                              access to files and printers when you pair Windows
                              11 Pro with Windows Server.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              kiosk Mode Setup
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Configure a device locally on the device or
                              remotely using Mobile Device Management.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Microsoft Store For Business
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Your one place to find, manage, and distribute
                              apps to Windows 11 Pro devices in volume.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Mobile Device Management
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              (MDM) provides an alternative to traditional PC
                              management processes so you can transition to
                              cloud-based management at your own pace.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Enyterprise State Roaming w/ Azure
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Available to any organization with an Azure AD
                              Premium or Enterprise Mobility + Security (EMS)
                              license. Enterprise State Roaming provides users
                              with a unified experience across their Windows
                              devices and reduces the time needed for
                              configuring a new device.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Support For Active Directory
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Domain Join + Group Policy: IT staff can easily
                              manage PC's, user accounts and groups, security
                              policies, and can get easy access to files and
                              printers when pairing with WIndows 11 Pro with
                              Windows Server.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Windows Update For Business
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Helps reduce management costs, provides control
                              over update deployments, enables efficient
                              delivery of updates, and provides access to the
                              latest innovations.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="product_accordion mt-5 me-3">
                  <Accordion>
                    <Accordion.Item eventKey="0" className=" box_shadow">
                      <Accordion.Header>
                        What is a digital download?
                      </Accordion.Header>
                      <Accordion.Body>
                        A digital download is an electronic version of your
                        software product which gives you access to download and
                        use your software immediately. This means a physical
                        package is not included with your purchase. You will
                        have the option to create a disc or USB at home or in
                        the office. Our support team would be happy to help
                        guide you through the process.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className=" box_shadow">
                      <Accordion.Header>
                        What is the difference between OEM & Retail licenses?
                      </Accordion.Header>
                      <Accordion.Body>
                        OEM licenses are pre-installed on the device and are
                        backed by the vendor. Retail licenses are powered by
                        Microsoft. You are free to install your product on any
                        device. Retail versions may be transferred to new
                        hardware but may only be installed on one device at a
                        time.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className=" box_shadow">
                      <Accordion.Header>
                        How can I guarantee that my copy of Microsoft software
                        is authentic?
                      </Accordion.Header>
                      <Accordion.Body>
                        Liberty Programs only purchases and distributes software
                        and licensing keys through our trusted Microsoft Partner
                        vendors. <br />
                        Any software purchased from Liberty Programs is covered
                        by our hassle-free 90-day money-back guarantee. We
                        encourage all of our customers to register their
                        Microsoft product key via the Microsoft phone activation
                        to ensure authenticity of their purchased products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className=" box_shadow">
                      <Accordion.Header>
                        Will my license key expire?
                      </Accordion.Header>
                      <Accordion.Body>
                        No, any product purchased from Liberty Programs is a
                        retail version which includes a lifetime license of your
                        software.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className=" box_shadow">
                      <Accordion.Header>
                        How long until I recieve my order?
                      </Accordion.Header>
                      <Accordion.Body>
                        Your order will typically be processed immediately.
                        Please login in to your account area with the
                        credentials given during the checkout process to find
                        your download media and license keys.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className=" box_shadow">
                      <Accordion.Header>
                        How do I download my software?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your download media for your purchased
                        software in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className=" box_shadow">
                      <Accordion.Header>
                        Where can I find the license keys to activate my
                        software
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your license key for your purchased
                        products in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7" className=" box_shadow">
                      <Accordion.Header>
                        How do I get help with my installation?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer a step-by-step PDF document that walks you
                        through the download process . If you need more
                        assistance please contact our support team and we would
                        be happy to help you with the installation via chat or
                        remote installation.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
              <Col xxl="3" md="3" sm="12">
                <div className="product_sidebar_widget darkblue_bg box_shadow">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Window11Pro;
